import { TextField } from '@material-ui/core'
import React from 'react'
import { useField } from 'react-final-form'

const RFFTextField = ({ label, ...props }) => {
  const { input, meta } = useField(props.name, props)

  return (
    <TextField
      fullWidth
      {...input}
      value={input.value || ''}
      label={label}
      error={meta.touched && meta.error}
      helperText={meta.touched && meta.error}
    />
  )
}

export default RFFTextField
